import geo from './raymonGeometry.json';

const norm = (text) => (text || '').toString().toLowerCase().replace(/\s+/g, ' ').trim();

// Which catalog geometry table belongs to a bike (some series have one table per travel or wheel size)
export function findGeometry(serieName, model) {
    const serie = norm(serieName);
    const name = norm(model);
    let key = null;

    if (serie === 'trailray') key = ['180', '170', '150', '120'].map(n => `Trailray ${n}`).find(k => name.includes(k.split(' ')[1]));
    else if (serie === 'rokua') key = name.includes('170') ? 'Rokua 170' : name.includes('150') ? 'Rokua 150' : null;
    else if (serie === 'yara') key = name.includes('150') ? 'Yara 150 Ultra' : name.includes('120') ? 'Yara 120' : null;
    else if (serie === 'ravor') key = / lt\b/.test(name) ? 'Ravor LT' : 'Ravor';
    else key = Object.keys(geo.tables).find(k => norm(k) === serie) || null;

    if (!key) return null;
    const table = geo.tables[key];
    // The rider-height table covers S, M, L and XL frames (not road sizes in cm or kids' wheel sizes)
    const hasHeights = table.frames.some(f => f.sizes.some(size => size in geo.heights));
    return { key, ...table, hasHeights };
}

// Frame tables for the frame type the customer picked (Diamond / Wave / Trapez); all of them if none matches
export function framesFor(geometry, selectedFrame) {
    const frames = geometry.frames;
    if (frames.length === 1 || !selectedFrame) return frames;
    const match = frames.filter(f => f.frame && norm(selectedFrame).includes(norm(f.frame)));
    return match.length ? match : frames;
}

export const RIDER_HEIGHTS = geo.heights;

export const kgToLb = (kg) => Math.round(kg * 2.20462);
export const GEOMETRY_SOURCE = geo.source;

export const GEOMETRY_ROWS = [
    { key: 'seat_tube', label: 'Largo del tubo de sillín', letter: 'A', unit: 'mm' },
    { key: 'reach', label: 'Reach', letter: 'B', unit: 'mm' },
    { key: 'stack', label: 'Stack', letter: 'C', unit: 'mm' },
    { key: 'top_tube', label: 'Tubo superior', letter: 'D', unit: 'mm' },
    { key: 'head_angle', label: 'Ángulo de dirección', letter: 'E', unit: '°' },
    { key: 'seat_angle', label: 'Ángulo del tubo de sillín', letter: 'F', unit: '°' },
    { key: 'head_tube', label: 'Tubo de dirección', letter: 'G', unit: 'mm' },
    { key: 'bb_drop', label: 'Caída del eje pedalier', letter: 'H', unit: 'mm' },
    { key: 'wheelbase', label: 'Distancia entre ejes', letter: 'I', unit: 'mm' },
    { key: 'chainstay', label: 'Vainas', letter: 'J', unit: 'mm' },
    { key: 'crank', label: 'Largo de bielas', unit: 'mm' },
    { key: 'stem', label: 'Largo de potencia', unit: 'mm' },
    { key: 'seatpost', label: 'Largo de tija', unit: 'mm' },
    { key: 'dropper', label: 'Recorrido de tija telescópica', unit: 'mm' },
    { key: 'handlebar', label: 'Ancho de manillar', unit: 'mm' }
];

// 153 cm -> 5′0″
export function cmToFeet(cm) {
    const totalInches = Math.round(cm / 2.54);
    return `${Math.floor(totalInches / 12)}′${totalInches % 12}″`;
}
